<template>
	<button :class="buttonClassList" @click="clicked($event)" :type="submit ? 'submit' : 'button'" v-tooltip="tooltip">
		<svg :class="classList" :width="iconSize" :height="iconSize" style="display: block; margin: 0 auto">
			<use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#' + type"></use>
		</svg>
	</button>
</template>

<script type="text/babel">
export default {
	props: {
		color: { default: "fade" }, // fade, brand, white, red, yellow, green, inherit
		extraClasses: { default: "" },
		type: { default: "" },
		flip: { default: false },
		submit: { default: false },
		tooltip: { default: null },
		rotate: { default: 0 },
		size: { default: "normal" }, // small, large
		buttonSize: { default: "normal" }, // small, input, input-large, large
	},

	methods: {
		clicked(event) {
			if (!this.submit) {
				event.preventDefault();
				event.stopPropagation();
			}

			this.$emit("clicked", event);
		},
	},

	computed: {
		iconSize() {
			switch (this.size) {
				case "small":
					return 14;

				default:
				case "normal-zerop":
				case "normal":
					return 16;

				case "inline-medium":
				case "medium":
					return 18;

				case "large":
					return 24;

				case "huge":
					return 48;
			}
		},

		viewBoxSize() {
			return "0 0 " + this.iconSize + " " + this.iconSize;
		},

		classList() {
			let classList = "icon";

			classList += " color-" + this.color;
			classList += " " + this.type;
			classList += " " + this.size;

			if (this.flip) {
				classList += " flip";
			}

			if (this.rotate !== 0) {
				classList += " rotate-" + this.rotate;
			}

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},

		buttonClassList() {
			let classList = "icon-button";

			classList += " size-" + this.buttonSize;
			classList += " icon-size-" + this.size;

			return classList;
		},
	},
};
</script>

<style lang="scss">
.icon {
	display: inline-block;
	vertical-align: middle;

	& + span {
		margin-left: 6px;
	}

	&.normal {
		width: 16px;
		height: 16px;
	}

	&.medium,
	&.inline-medium {
		width: 18px;
		height: 18px;
	}

	&.large {
		width: 24px;
		height: 24px;
	}

	// Flip
	&.flip {
		transform: scaleX(-1);
	}

	&.rotate-45 {
		transform: rotate(45deg);
	}

	&.rotate-90 {
		transform: rotate(90deg);
	}

	&.rotate-135 {
		transform: rotate(135deg);
	}

	&.rotate-180 {
		transform: rotate(180deg);
	}

	&.rotate-225 {
		transform: rotate(225deg);
	}

	&.rotate-270 {
		transform: rotate(270deg);
	}

	&.rotate-315 {
		transform: rotate(315deg);
	}

	// Colors
	&.color-inherit {
		color: inherit;
	}

	&.color-fade {
		color: #a8b1c3;
	}

	&.color-white {
		color: #fff;
	}

	&.color-brand {
		color: #7061ff;
	}

  &.color-red {
    color: #de6d6d;
  }

  &.color-yellow {
    color: #caa46e;
  }

  &.color-green {
    color: #99c075;
  }
}

span + .icon {
	margin-left: 6px;
}
</style>
